module.exports = __webpack_public_path__ + "static/media/screenshot(33).e1f88116.jpg";